import styles from "../../styles/layout/layout.module.css"
import "../../styles/layout/footer.css"
import {getIcon, getLogo} from "../../utils/helper";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {smoothScrollToId} from "./Header";

export const Footer = () => {
    const location = useLocation();
    const [activeLink, setActiveLink] = useState('');
    const navigate = useNavigate();  // Khởi tạo hook useNavigate
    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location.pathname]);
    const menus = [
        {
            label: "StartSeite",
            url: "/"
        },
        {
            label: "Speisekarte",
            url: "/speisekarte"
        },
        {
            label: "Über uns",
            url: "#",
            id: 'about-us',
            nonRedirect: true,
        }, {
            label: "Party Catering & Events",
            url: "#",
            id: 'party-event',
            nonRedirect: true,
        },
        // {
        //     label: "Online bestellen",
        //     url: "https://d-gastro24.de/order/hamirestaurant",
        //     target: "_blank"
        // },
        {
            label: "Tisch reservieren",
            url: "#",
            id: 'tisch-reservieren',
            nonRedirect: true,
        },
        // {
        //     label: "Impressum",
        //     url: "#"
        // }, {
        //     label: "Datenschutz",
        //     url: "#"
        // },
        {
            label: "Kontaktieren Sie uns",
            url: "/kontaktieren-sie-uns"
        },

    ]
    const menusSocial = [
        {
            label: "Facebook",
            url: "https://www.facebook.com/hami.freiberg/"
        },
        {
            label: "Instagram",
            url: "https://www.instagram.com/ha_mi.freiberg/"
        },
        // {
        //     label: "Twitter",
        //     url: "#"
        // },
        // {
        //     label: "Youtube",
        //     url: "#"
        // },
        {
            label: "Google Map",
            url: "https://maps.app.goo.gl/dczj2LdVkYREyRVk8"
        },
    ]
    return (

        <>
            <iframe className={styles.iframeAddress}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2515.126640895376!2d13.343730299999997!3d50.9213743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a7600123ec9fc3%3A0x644abe9c2ff7c739!2zTcO2bmNoc3N0cmHDn2UgMSwgMDk1OTkgRnJlaWJlcmcsIMSQ4bupYw!5e0!3m2!1svi!2s!4v1744121030050!5m2!1svi!2s"
                    width="600" height="450" allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            <footer className={`footer section has-bg-image text-center containerFooter`}>
                <div className="container-footer">

                    <div className="footer-top grid-list">


                        <ul className="footer-list">
                            {
                                menus?.map(({label, url, nonRedirect, id, target}, index) => {
                                    return <li key={index}>
                                        <div onClick={() => {
                                            if (target) {
                                                window.open(url, target);
                                            } else if (nonRedirect) {

                                                smoothScrollToId(id, 'start', 'nearest', navigate)

                                            } else {
                                                navigate(url)
                                            }
                                        }}
                                             className={`${styles.navbarLink} ${styles.hoverUnderline} ${activeLink === url ? styles.active : ""}`}>
                                            {label}
                                        </div>
                                    </li>
                                })
                            }

                        </ul>
                        <div className="footer-brand has-before has-after">

                            <Link to="/" className="footer-logo">
                                {getLogo()}
                            </Link>
                            <Link to="https://maps.app.goo.gl/dczj2LdVkYREyRVk8">
                                <address className="body-4">
                                    Mönchstraße 01, 09599 Freiberg
                                </address>
                            </Link>

                            <a href="mailto:info.hami.freiberg@gmail.com"
                               className="body-4 contact-link">info.hami.freiberg@gmail.com</a>

                            <a href="tel:+4937312188290" className="body-4 contact-link">Besuchen Sie uns :
                                +4937312188290</a>

                            <p className="body-4">
                                Öffnungszeiten: Montag geschlossen, Dienstag-Sonntag 11:00-15:00 und 17:00-22:00
                            </p>
                            <p className="body-4">
                                Mittagskarte: Dienstag-Sonntag 11:00-15:00
                            </p>

                            <p className="body-4">
                                Kücheschluss: 21h30
                            </p>

                            <div className="wrapper">
                                <div className={styles.separator}></div>
                                <div className={styles.separator}></div>
                                <div className={styles.separator}></div>
                            </div>

                            <p className="title-1">Bleib über Neuigkeiten und Angebote informiert</p>

                            <p className="label-1">
                                Abonnieren Sie uns und erhalten Sie <span className="span">Werbeinformationen</span>
                            </p>

                            <Link to="/kontaktieren-sie-uns">
                                <button type="button" className={`btnSecondary btn`}>
                                    <span className={`text text1`}>Kontaktieren Sie uns</span>
                                    <span className={`text text2`} aria-hidden="true">Kontaktieren Sie uns</span>
                                </button>
                            </Link>
                            {/*</form>*/}

                        </div>
                        <ul className="footer-list">
                            {
                                menusSocial?.map(({label, url}, index) => {
                                    return <li key={index}>
                                        <Link to={url} target={"_blank"}
                                              className={`${styles.navbarLink} ${styles.hoverUnderline} ${activeLink === url ? styles.active : ""}`}>
                                            {label}
                                        </Link>
                                    </li>
                                })
                            }

                        </ul>
                    </div>
                    <div className="footer-bottom">

                        <p className="copyright">
                            &copy; 2022 Hami. All <Link className={"link"} to={"/impressum"}>
                            Impressum
                        </Link> | < Link className={"link"} to={"/datenschutz"}>
                            Datenschutz
                        </Link>

                        </p>

                    </div>

                </div>
            </footer>
        </>


    )
}